import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

const root = ReactDOM.createRoot(document.getElementById('root'));

// Session refresh function with retry logic
const refreshSession = async (retries = 3) => {
  for (let i = 0; i < retries; i++) {
    try {
      const resp = await fetch('/api/session', { 
        method: 'POST',
        credentials: 'include',
        headers: { 'Content-Type': 'application/json' }
      });
      
      if (resp.ok) {
        // Small delay to ensure cookie is set (important for Vercel/cross-domain)
        await new Promise(resolve => setTimeout(resolve, 100));
        return true;
      }
      
      // If not ok and not last retry, wait before retrying
      if (i < retries - 1) {
        await new Promise(resolve => setTimeout(resolve, 500 * (i + 1)));
      }
    } catch (error) {
      if (i < retries - 1) {
        await new Promise(resolve => setTimeout(resolve, 500 * (i + 1)));
      }
    }
  }
  return false;
};

// Start session refresh on page load and then every 90 minutes
const SESSION_REFRESH_INTERVAL = 90 * 60 * 1000; // 90 minutes in milliseconds
refreshSession(3); // Initial session creation
setInterval(() => refreshSession(1), SESSION_REFRESH_INTERVAL);

root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
